import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { Ng5SliderModule } from 'ng5-slider';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { httpInterceptorProviders } from './connect';

import { AppComponent } from './app.component';
import { ComponentModule } from './component.module';

import { GooglePlaceModule } from "ngx-google-places-autocomplete";

import { AccountComponent } from './components/account/account.component';
import { LoginComponent } from './components/account/login/login.component';
import { RegisterComponent } from './components/account/register/register.component';
import { TermsOfServiceComponent } from './components/account/termsofservice.component';

import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { EffectsModule } from "@ngrx/effects";
import { GlobalErrorHandler } from './services/error.handler';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
//import { ServiceWorkerModule } from '@angular/service-worker';

import { OAuthModule } from 'angular-oauth2-oidc';

@NgModule({
  declarations: [
    AppComponent,
    AccountComponent,
    LoginComponent,
    RegisterComponent,
    TermsOfServiceComponent,
    MaintenanceComponent
  ],
  imports: [        
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    ComponentModule,    
    CarouselModule.forRoot(), 
    BsDropdownModule.forRoot(),
    GooglePlaceModule,
    Ng5SliderModule,
    NgIdleKeepaliveModule.forRoot(),
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument(),
    OAuthModule.forRoot()
    /*ServiceWorkerModule.register('ngsw-worker.js', { enabled: true })*/
  ],
  exports: [
  ],
  providers: [
    CookieService,
    MatSnackBar,
    httpInterceptorProviders,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}



